export const PRESETS = {
  searchResult: {
    pageSize: 20,
    listHeight: {
      desktop: 250,
      mobile: 350,
    },
    autoCompleteHeight: {
      desktop: 275,
      mobile: 375,
    },
  },
  infineScroll: {
    delay: 500,
  },
};
